import Services from '../../service/ApiServices'
import { GetDateISOString } from '../../utilities/DateHelper';
import _ from 'lodash'


export const ASSIGN_RESERVE_BED = "ASSIGN_RESERVE_BED";
export const REMOVE_ASSIGN_RESERVE = "REMOVE_ASSIGN_RESERVE"
export const MOVE_CLIENT = "MOVE_CLIENT"

export const SELECTED_DATE = "CENSUS/SELECTED_DATE"
export const SET_FILTER = "CENSUS/SET_FILTER"
export const RESET_FILTER = "CENSUS/RESET_FILTER"
export const SET_SELECTED_LOCATIONS = "CENSUS/SET_SELECTED_LOCATIONS"
export const INITIALIZE_DEFAULTS = "CENSUS/INITIALIZE_DEFAULTS"
export const SET_DEFAULT_EXPANDED_KEYS = "CENSUS/SET_DEFAULT_EXPANDED_KEYS"
export const SET_CLIENT_STATUS = "CENSUS/SET_CLIENT_STATUS"

export const InitialDefaults = (date, selectedLocations)=>{
    return {type: INITIALIZE_DEFAULTS, defaults:{date, selectedLocations}}
}
export const SetDefaultExpandedKeys = (expandedKeys)=>{
    return {type:SET_DEFAULT_EXPANDED_KEYS, expandedKeys}
}
export const SetSelectedLocations = (selectedLocations)=>{
    return {type: SET_SELECTED_LOCATIONS, selectedLocations}
}

export const SetSelectedDate = (date)=>{
    return {type: SELECTED_DATE, date:date}
}

export const SetFilter = (data)=>{
    return {type: SET_FILTER, filter:data}
}

export const ResetFilter = ()=>{
    return {type: RESET_FILTER}
}

export const AssignOrReserveBed = async (bed, data)=>{
    let response = null 
    if(_.get(data, "assignmentId"))
        response =  await Services.Census.updateBedAssignOrReserve({...data, startDate:GetDateISOString(data.startDate), endDate:GetDateISOString(data.endDate)})
    else
        response =  await Services.Census.saveBedAssignOrReserve({...data, startDate:GetDateISOString(data.startDate), endDate:GetDateISOString(data.endDate)});
   
    return {type: ASSIGN_RESERVE_BED, bed:bed, data:response.data }
}

export const RemoveAssignOrReserve = async(bed, data)=>{
    let response = null
    if(_.get(data, "assignmentId"))
        response =  await Services.Census.updateBedAssignOrReserve({...data, startDate:GetDateISOString(data.startDate), endDate:GetDateISOString(data.endDate)})
    return {type:REMOVE_ASSIGN_RESERVE, bed:bed, data:response.data}

}

export const MoveClient = async(bed, formData)=>{   
    const data = {assignmentId: formData.assignmentId, oldBedId: formData.bedId, newBedId: formData.bed.id, date:formData.date}
    const response = await Services.Census.moveClient(data);  
    return {type:MOVE_CLIENT, oldBed: bed, newBed: formData.bed, newAssignmentId: response.data.assignmentId}

}

export const SetClientStatus = (data)=>{
    return {type: SET_CLIENT_STATUS, clientStatus:data}
}

